import GenericTable from '../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import leasingReportTableData from './leasingReportTableData'
import type { Leasing } from '../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../utils/formatNumber'
import { formatDate } from '../../../../cars/components/V3/helpers/formatDate'
import TableMobileCardContent from '../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'

type LeasingReportTableProps = {
  data: Leasing[]
  isLoading?: boolean
}

function LeasingReportTable({ data, isLoading }: LeasingReportTableProps) {
  const columns = leasingReportTableData()

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row as Row<Leasing>} />
      }}
    />
  )
}

export default LeasingReportTable

function MobileCardContent({ row }: { row: Row<Leasing> }) {
  const settings = {
    digits: {
      min: 0,
      max: 0,
    },
    prefix: 'kr ',
  }

  const data = [
    {
      label: 'Regnr',
      value: row.original.regNo || '',
    },
    {
      label: 'Kjøretøy-ID',
      value: row.original.vehicleID || '',
    },
    {
      label: 'Samlefakturakode',
      value: `${row.original.consolidatedAgreementID} - ${row.original.consolidatedAgreement}` || '',
    },
    {
      label: 'Sjåfør',
      value: row.original.driverName || '',
    },
    {
      label: 'Maks km',
      value: formatNumber(row.original.maxKm),
    },
    {
      label: 'Terminer totalt',
      value: row.original.totalTerms || '',
    },
    {
      label: 'Terminer løpt',
      value: row.original.termsNow || '',
    },
    {
      label: 'Terminer gjenstår',
      value: row.original.remainingTerms || '',
    },
    {
      label: 'Startdato',
      value: formatDate(row.original.startDate) || '',
    },
    {
      label: 'Returdato',
      value: formatDate(row.original.returnDate) || '',
    },
    {
      label: 'Leasingleie mnd ink. mva',
      value: formatNumber(row.original.termLeasingInclVAT, settings) || '',
    },
    {
      label: 'Leasing forpliktelser ink. mva',
      value: formatNumber(row.original.restLeasingInclVAT, settings) || '',
    },
    {
      label: 'Leasing forpliktelser eks. mva',
      value: formatNumber(row.original.restLeasingExclVAT, settings) || '',
    },
  ]
  const header = `Leasing - ${row.original.regNo}`
  return <TableMobileCardContent header={header} data={data} />
}
